<script lang="ts">
  import Notes from "./Notes.svelte";
  import { auth, provider } from "./firebase";
  import {
    setPersistence,
    browserLocalPersistence,
    signInWithPopup,
    GoogleAuthProvider,
    signInWithRedirect,
  } from "firebase/auth";

  import { authState } from "rxfire/auth";

  let user;

  authState(auth).subscribe((u) => (user = u));

  function login() {
    setPersistence(auth, browserLocalPersistence).then(() => {
      signInWithPopup(auth, provider)
        .then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          const credential = GoogleAuthProvider.credentialFromResult(result);
          const token = credential.accessToken;
          // The signed-in user info.
          user = result.user;
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          // The email of the user's account used.
          const email = error.email;
          // The AuthCredential type that was used.
          const credential = GoogleAuthProvider.credentialFromError(error);

          console.error({ errorCode, errorMessage, email, credential });
        });
    });
  }
</script>

<svelte:head>
  <html lang="en" />
  <title>Notes</title>
  <meta name="robots" content="noindex nofollow" />
  <meta name="viewport" content="width=device-width, user-scalable=no" />

  <link rel="stylesheet" href="https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.3.0/css/line-awesome.min.css">
  <link type="text/css" rel="stylesheet" href="https://unpkg.com/lightgallery@2.3.0/css/lightgallery-bundle.min.css" />

  <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
  <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
  <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
  <link rel="manifest" href="/site.webmanifest" />
  <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
  <meta name="msapplication-TileColor" content="#da532c" />
  <meta name="theme-color" content="#ffffff" />
</svelte:head>

<main>
  <section>
    {#if user}
      <div class="user-container">
        <img src={user.photoURL} alt="user avatar" />
        <div>
          <p>{user.email}</p>
          <a href={null} on:click={() => auth.signOut()}>Logout</a>
        </div>
      </div>

      <Notes uid={user.uid} />
    {:else}
      <button on:click={login}> Signin with Google </button>
    {/if}
  </section>
</main>

<style>
  main {
    padding: 1rem;
    max-width: 85ch;
    margin: 0 auto;
    position: relative;
  }

  button {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1rem;
    max-height: 2rem;
  }

  .user-container {
    display: flex;
    align-items: center;
    height: 35px;
    margin-bottom: 1rem;
  }

  .user-container img {
    width: 30px;
    border-radius: 4px;
    margin-right: 8px;
  }

  .user-container div {
    display: flex;
    flex-direction: column;
  }
  .user-container p {
    margin: 0;
    margin-right: 8px;
    font-size: 12px;
    font-weight: bold;
  }

  .user-container a {
    font-size: 11px;
    cursor: pointer;
  }

  :global(button) {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    font-weight: 600;
    border: 1px solid #ccc;
    background-color: transparent;
  }
</style>
